import React from "react";
import { observer } from "mobx-react";
import numeral from "numeral";
import CartStore from "../../../stores/CartStore";
import { Button, Spinner } from "../../-common";
import "./CheckoutButton.scss";

const CheckoutButton = ({ style, action, disabled, processing, hasProductsToShip, canRetry, errorType }) => {
  // Determine button content based on state
  const getButtonContent = () => {
    if (processing) return <Spinner />;
    
    if (canRetry && errorType) {
      switch (errorType) {
        case 'PAYMENT_ERROR':
          return 'RETRY PAYMENT';
        case 'PROCESSING_FAILED':
          return 'RETRY REGISTRATION';
        default:
          return 'TRY AGAIN';
      }
    }
    
    if (hasProductsToShip) {
      return `COMPLETE PURCHASE (${numeral(CartStore?.total / 100).format("$0,00.00")})`;
    }
    
    return "COMPLETE ENROLLMENT";
  };
  
  const actionButtonContent = getButtonContent();

  return (
    <Button 
      type="cta" 
      className="checkout-button" 
      style={style} 
      action={action} 
      disabled={disabled}
      preventDefaultAndPropagation={true}
    >
      {actionButtonContent}
    </Button>
  );
};

export default observer(CheckoutButton);
